import { deleteCookie, getCookie } from 'cookies-next'

import { HASH_KEY, TOKEN_KEY } from '@/common/constants/cookies'

import { AuthApi } from './AuthApi'
import { PartnersApi } from './PartnersApi'
import { UserApi } from './UserApi'
import { BillingApi } from './BillingApi'
import { TariffsApi } from '@/common/services/api/TariffApi'
import { StatsApi } from '@/common/services/api/StatsApi'
import { ProfileApi } from '@/common/services/api/ProfileApi'

import getConfig from 'next/config'
import { createAxiosInstance } from '@/common/services/api/utils/createAxiosInstance'
import { createAxiosStrapiInstance } from '@/common/services/api/utils/createAxiosStrapiIntance'
import { FaqApi } from '@/common/services/api/FaqApi'
import { HowToPayApi } from '@/common/services/api/HowToPayApi'
import { BuilderApi } from '@/common/services/api/BuilderApi'
import { WikiApi } from '@/common/services/api/WikiApi'
import { AdvicesApi } from '@/common/services/api/AdvicesApi'
import { CreativesApi } from '@/common/services/api/CreativesApi'
import { HelpApi } from '@/common/services/api/HelpApi'
import { AppsApi } from '@/common/services/api/AppsApi'
import { OnboardingApi } from '@/common/services/api/OnboardingApi'

const getToken = () => getCookie(TOKEN_KEY)

const clearToken = () => {
  deleteCookie(TOKEN_KEY)
  deleteCookie(HASH_KEY, {
    domain: `.${getConfig().publicRuntimeConfig.baseDomain}`,
  })
}

const baseInstance = createAxiosInstance({ getToken, clearToken })
const strapiInstance = createAxiosStrapiInstance()

export const authApi = new AuthApi(baseInstance)
export const appsApi = new AppsApi(baseInstance)
export const partnersApi = new PartnersApi(baseInstance)
export const userApi = new UserApi(baseInstance)
export const billingApi = new BillingApi(baseInstance)
export const tariffApi = new TariffsApi(baseInstance)
export const statsApi = new StatsApi(baseInstance)
export const profileApi = new ProfileApi(baseInstance)
export const faqApi = new FaqApi(strapiInstance)
export const howToPayApi = new HowToPayApi(strapiInstance)
export const helpApi = new HelpApi(strapiInstance)
export const wikiApi = new WikiApi(strapiInstance)
export const advicesApi = new AdvicesApi(strapiInstance)
export const builderApi = new BuilderApi(strapiInstance)
export const creativesApi = new CreativesApi(baseInstance)
export const onboardingApi = new OnboardingApi(baseInstance)
